import sanityClient from "@sanity/client";

export const sanityConfiguration = {
  projectId: "n26ewl9d",
  dataset: "production",
  token: "", // or leave blank to be anonymous user
  useCdn: false, // `false` if you want to ensure fresh data
};

// Source: https://stackoverflow.com/a/64539748
export const getUrlFromId = (ref) => {
  if (!ref) return;
  // Example ref: file-207fd9951e759130053d37cf0a558ffe84ddd1c9-mp3
  // We don't need the first part, unless we're using the same function for files and images
  const [_file, id, extension] = ref.split("-");
  return `https://cdn.sanity.io/files/${sanityConfiguration.projectId}/${sanityConfiguration.dataset}/${id}.${extension}`;
};

export const client = sanityClient(sanityConfiguration);
